/**
 * Defines the events associated with the radiobutton component.
 */
export const RadioButtonEvents = {
  CHECKED: 'luds-radio-button:checked',
} as const;

export const RadioButtonGroupEvents = {
  VALUE_CHANGED: 'luds-radio-button-group:value-changed',
} as const;

// Define the CheckedEvent interface
export interface CheckedEvent {
  checked: boolean;
  disabled: boolean;
  indeterminate: boolean;
  label: string;
  radioButtonAriaLabel: string | null;
  name: string;
  id: string;
  value: string;
}

// Define the CheckedEvent interface
export interface GroupCheckedEvent {
  value: string;
}
